/*
 * shopit-api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.41
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The PromotionsActive model module.
 * @module model/PromotionsActive
 * @version v1
 */
export class PromotionsActive {
  /**
   * Constructs a new <code>PromotionsActive</code>.
   * @alias module:model/PromotionsActive
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>PromotionsActive</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/PromotionsActive} obj Optional instance to populate.
   * @return {module:model/PromotionsActive} The populated <code>PromotionsActive</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new PromotionsActive();
    }
    return obj;
  }
}
